/**
 *公用工具类
 *@author xujinjiang
 *@date 2022/3/14 16:25
 */

import { LocalStorageManager } from '@/db/LocalStorageManager';
import { ElLoading, ElMessage } from 'element-plus/es';

export class CommonUtil {
  /**
   * 错误提示
   * @param message
   */
  public static errorMessage(message: any) {
    ElMessage({
      message: message,
      type: 'error',
      center: true,
      offset: 140
    });
  }

  /**
   * 警告提示
   * @param message
   */
  public static warningMessage(message: any) {
    ElMessage({
      message: message,
      type: 'warning',
      center: true,
      offset: 140
    });
  }

  /**
   * 成功提示
   * @param message
   */
  public static successMessage(message: any) {
    ElMessage({
      message: message,
      type: 'success',
      center: true,
      offset: 140
    });
  }

  /**
   * loading
   * @param el
   */
  public static loading(selector: any) {
    const el = document.querySelector(selector) as any;
    return ElLoading.service({
      target: el,
      lock: true,
      text: 'Loading',
      background: '#FFFFFF'
    });
  }

  public static getDate(time: any) {
    const year = time.getFullYear() + '-';
    const mon = time.getMonth() + 1;
    const month = (mon < 10 ? '0' + mon : mon) + '-';
    const date = time.getDate();
    const day = (date < 10 ? '0' + date : date) + ' ';
    return year + month + day;
  }

  /**
   * 检查接口返回的省字段是否为空
   */
  public static checkEmpetyProvince(province: any, city: any, area: any) {
    if (!province || province === '') {
      return '-';
    }
    const City = city ? city : '';
    const Area = area ? area : '';
    return province + City + Area;
  }

  /*
      60秒手机短信按钮倒计时
      */
  public static cutDownTimer(selector: string, key?: string) {
    const element = document.querySelector(selector) as HTMLInputElement;
    if (!element) {
      return;
    }

    let second = 60;

    // if (second === 60) {
    //     localStorage.setItem(key, new Date().getTime() + '');
    // }

    const updateTimeLoader = () => {
      setTimeout(() => {
        if (second === 0) {
          element.classList.remove('disable');
          element.innerHTML = '重新获取验证码';
        } else {
          second--;
          element.classList.add('disable');
          element.innerHTML = second + '秒后重试';
          updateTimeLoader();
        }
      }, 1000);

    };
    updateTimeLoader();
  }

  public static getDevelopUser() {
    const developUserStr = LocalStorageManager.getItem('developUser');
    if (!developUserStr) {
      return;
    }
    return  JSON.parse(developUserStr);
  }
}
